import { MAX_RESPAWN_POINT_NAME_CHARS } from "../protocol/respawn.ts";

/**
 * The fields a travel place carries beside its name (ADR-137 decisions 2, 3 and 19). A place is a shrine or a waypoint
 * (a portal stone): both may be Known from the start, both may be a town's, and a waypoint names a region. They are
 * authored booleans and text, read the same way wherever a place's placed fields are read.
 */

/**
 * The field of a shrine or a waypoint that makes every character know it from its join, by rule and with no row.
 */
export const KNOWN_FROM_START_FIELD = "knownFromStart";

/**
 * The field of a shrine or a waypoint that marks it a town's, which a trip to costs no coin from a shrine.
 */
export const TOWN_FIELD = "town";

/**
 * The field of a waypoint that groups it in the travel list.
 */
export const REGION_FIELD = "region";

/**
 * The most characters of a region name, as long as a place's name.
 */
export const MAX_PLACE_REGION_CHARS = MAX_RESPAWN_POINT_NAME_CHARS;

/**
 * Whether a place's fields mark it known to every character from its join. The starting shrine (`start`, one a map) is
 * a mark of its own (`isStartingShrine`); this reads `knownFromStart`, which any number of places may carry.
 *
 * @param fields The place's placed fields.
 * @returns True only for the boolean `knownFromStart: true`.
 */
export function isKnownFromStart(fields: Readonly<Record<string, unknown>> | undefined): boolean {
  return fields?.[KNOWN_FROM_START_FIELD] === true;
}

/**
 * Whether a place's fields mark it a town's.
 *
 * @param fields The place's placed fields.
 * @returns True only for the boolean `town: true`.
 */
export function isTownPlace(fields: Readonly<Record<string, unknown>> | undefined): boolean {
  return fields?.[TOWN_FIELD] === true;
}

/**
 * A place's region from its placed fields: the text trimmed and held to what the wire carries.
 *
 * @param fields The place's placed fields.
 * @returns The region, empty for none.
 */
export function placeRegion(fields: Readonly<Record<string, unknown>> | undefined): string {
  const region = fields?.[REGION_FIELD];
  return typeof region === "string" ? region.trim().slice(0, MAX_PLACE_REGION_CHARS) : "";
}
